import { isIndicationFromBackend } from './index';
import { formatOptionsFromServerData } from './formatOptionsFromServerData';

export async function getOptionsFromServer(disease, question, optionsFromServer) {
  if (isIndicationFromBackend(disease)) {
    const options = question.options.map((option) => ({
      code: option.value,
      name: option.label,
      topSelectedForConditions: option.topSelectedForConditions,
    }));
    return formatOptionsFromServerData(options, question.id);
  }

  return optionsFromServer[question.id] ?? {};
}
